import { paths } from '../../../utils/constants/routes';
import { ACCOUNT_TYPES } from '../../../utils/constants/auth';
import { buildProjectResultsUrl } from '../../../utils/profiler/buildProjectResultsUrl';
import { SELECTED_PROJECT_TABS as PROFILER_PROJECT_TABS } from '../../ProfilerProjects/constants';
import { SELECTED_PROJECT_TABS as PROJECT_TABS } from '../../Projects/constants';

const SAVED_PROJECTS_PARAMS = {
  projectTypeTab: 'saved',
  projectSort: 'DATE_DESC',
  projectTypePage: 1
};

/**
 * Link to a Profiler search saved as a project. Agent accounts keep their projects on the
 * Projects page (Profiler filter on), every other account on the Profiler projects page; the
 * Agent route does not open for an Investor account (it lands on home).
 *
 * @param {string} userAccountType - authStore.userAccountType
 * @param {string} [projectId] - the saved project; opens its results. Without one, the
 *   saved-projects list.
 * @returns {string} app path with an encoded `?params=` query
 */
export const savedProfilerProjectUrl = (userAccountType, projectId) => {
  const isAgent = userAccountType === ACCOUNT_TYPES.AGENT;
  const listPath = isAgent ? paths.PROJECTS : paths.PROFILER_PROJECTS;
  const params = isAgent
    ? { ...SAVED_PROJECTS_PARAMS, projectProfileFilter: 'profiler' }
    : SAVED_PROJECTS_PARAMS;
  if (!projectId) {
    return `${listPath}?params=${encodeURIComponent(JSON.stringify(params))}`;
  }
  const resultsTab = isAgent ? PROJECT_TABS.RESULTS : PROFILER_PROJECT_TABS.RESULTS;
  return buildProjectResultsUrl(listPath, params, projectId, resultsTab);
};
